export const Nyasvizh = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [26.36867795172617, 53.36115925609488],
            [26.372614530736143, 53.35308464633948],
            [26.377376914013382, 53.34783648166848],
            [26.381040285281074, 53.33974429376434],
            [26.37774325105022, 53.330994255380745],
            [26.37371354184654, 53.32639976653604],
            [26.375911564966884, 53.32224242195031],
            [26.38323830840119, 53.31896002148795],
            [26.396426447122906, 53.31808467177024],
            [26.40082249426274, 53.31567736921528],
            [26.40155516833653, 53.310643477014935],
            [26.40082249426274, 53.306703495869726],
            [26.394594761938777, 53.30254423213074],
            [26.391664063845496, 53.29750879219711],
            [26.39398658461323, 53.28572347266032],
            [26.39488096218679, 53.276098124129305],
            [26.39398658461323, 53.26593568158654],
            [26.38325405013444, 53.25898103894394],
            [26.37162713718277, 53.25844602056753],
            [26.351056444899143, 53.25844602056753],
            [26.34032391042024, 53.25630587601546],
            [26.339429531947417, 53.24613872911914],
            [26.337640775901207, 53.23918086780287],
            [26.327802618995747, 53.23543385778629],
            [26.317070084516786, 53.23543385778629],
            [26.309915061231152, 53.23115116029794],
            [26.31259819485092, 53.22097803470871],
            [26.30902068275833, 53.215622787761504],
            [26.30097128189925, 53.211873716498985],
            [26.294710636187006, 53.210266871718886],
            [26.27950621204218, 53.20705299959633],
            [26.275928700848965, 53.201696011561864],
            [26.27771745599597, 53.194730926890884],
            [26.28487247928166, 53.1883006123835],
            [26.296499392233216, 53.18722879946955],
            [26.31259819485092, 53.186156960475444],
            [26.326013863848857, 53.18347724338008],
            [26.335852019854997, 53.17597314824229],
            [26.341218287993627, 53.16793158767268],
            [26.345689241333275, 53.1582817480392],
            [26.358211468184834, 53.146480059807004],
            [26.368049625090123, 53.13896949224835],
            [26.380570915615294, 53.13199421825868],
            [26.393092207939162, 53.12394441720113],
            [26.408296631184726, 53.12072407445663],
            [26.41813478898945, 53.11696670335084],
            [26.43691672522681, 53.11535630085274],
            [26.452121149371578, 53.11750349069359],
            [26.465536818369515, 53.118577045594236],
            [26.46722885233652, 53.118577045594236],
            [26.457782092890852, 53.126513762063325],
            [26.45206828666096, 53.13199912455127],
            [26.445211718286885, 53.13645546558098],
            [26.439212220847253, 53.141254085717776],
            [26.436069627420864, 53.14399591393703],
            [26.432641343682917, 53.149307707016874],
            [26.434641175863305, 53.15016438684671],
            [26.440354982093254, 53.152734322176514],
            [26.442069124860495, 53.15444752694458],
            [26.44549740859827, 53.158558940020214],
            [26.456925021956465, 53.16027191236941],
            [26.464352970953485, 53.15873024033118],
            [26.467495564380044, 53.15598935332673],
            [26.467781254691488, 53.15410489145984],
            [26.47120953932773, 53.15119237943645],
            [26.476637655246066, 53.149650381322886],
            [26.480637319607013, 53.14982171718111],
            [26.485208365489086, 53.15119237943645],
            [26.48806526860409, 53.15136370914206],
            [26.494350456355335, 53.14913636910768],
            [26.49549321760128, 53.14502405419455],
            [26.49777874009328, 53.142282291608524],
            [26.50034995289667, 53.13851208301219],
            [26.504920998778914, 53.1335417564448],
            [26.517205683071325, 53.130113609818125],
            [26.52177672895357, 53.130285023618285],
            [26.52863329642946, 53.13148490161274],
            [26.53663262604948, 53.13285614910751],
            [26.544346265358115, 53.13148490161274],
            [26.549488690965063, 53.12754232076355],
            [26.557202330273697, 53.12497087731765],
            [26.56748718238572, 53.12548517874649],
            [26.573200989513964, 53.12857085484745],
            [26.575772202317353, 53.13234193642512],
            [26.57348667982552, 53.13628407639584],
            [26.57062977581228, 53.141254085717776],
            [26.57348667982552, 53.14536676214442],
            [26.580057556989857, 53.14433863009094],
            [26.585485673806545, 53.140739973542566],
            [26.596056216230124, 53.13474154296097],
            [26.605198307096146, 53.130456436734676],
            [26.610340732703094, 53.1278851681933],
            [26.622054036372504, 53.12497087731765],
            [26.636052863432326, 53.120170438904665],
            [26.649765999282295, 53.113997658334426],
            [26.660336541705874, 53.108166996169984],
            [26.68204900717609, 53.100620259371624],
            [26.690334027107724, 53.09907644575884],
            [26.698333356727744, 53.099934126827975],
            [26.70376147264608, 53.101306381510994],
            [26.70918958946271, 53.103193159483794],
            [26.713760634446658, 53.10559439357519],
            [26.72204565437829, 53.10885299739573],
            [26.729759293686925, 53.10936749113364],
            [26.735187410503556, 53.107823991453756],
            [26.740329836110504, 53.10405075847666],
            [26.744043810159894, 53.09787566353464],
            [26.751471759157084, 53.092900636732],
            [26.762327991892107, 53.091528114458924],
            [26.769184560266353, 53.092900636732],
            [26.774612676184688, 53.09718948721604],
            [26.778326651132375, 53.10216401812164],
            [26.785754600129565, 53.10593741607374],
            [26.794039619162902, 53.105765905166436],
            [26.801181877848535, 53.10267859188053],
            [26.80632430435361, 53.10079179079747],
            [26.8120381105835, 53.10027719446771],
            [26.819466059580748, 53.100105660989755],
            [26.825751247331823, 53.09941952023843],
            [26.83032229231577, 53.09821874759018],
            [26.830536215007726, 53.09798159991254],
            [26.83167932151997, 53.10209969590153],
            [26.832125712350944, 53.109067370399714],
            [26.83480405913349, 53.11228283938499],
            [26.84149992698815, 53.11523014158888],
            [26.84774940311337, 53.11817724176984],
            [26.848195793944512, 53.12112413993373],
            [26.84596383799294, 53.12701733023499],
            [26.841946317819122, 53.12969578618646],
            [26.839267971036577, 53.13290971254099],
            [26.83748240591592, 53.139069066342586],
            [26.840160753596763, 53.14335331364299],
            [26.84373188204131, 53.14763713310657],
            [26.85042774989597, 53.15352668781128],
            [26.854891660900876, 53.15807715399524],
            [26.85667722602136, 53.16343002610671],
            [26.857570008581604, 53.168782231239845],
            [26.860248355364206, 53.17520399546777],
            [26.86248031041748, 53.17948463802588],
            [26.863373092977724, 53.184032352523275],
            [26.860694746195122, 53.188044641201145],
            [26.858016399412577, 53.1931263350034],
            [26.859355572803963, 53.20007925553409],
            [26.86203391958651, 53.20596161539589],
            [26.86694422232057, 53.208100455224326],
            [26.870515351663357, 53.21104118561277],
            [26.872300915885717, 53.21531825144888],
            [26.870515351663357, 53.21879305256931],
            [26.872033081386974, 53.22206445407386],
            [26.87717550789222, 53.22411697099204],
            [26.882032243187552, 53.22599835792721],
            [26.8860319075485, 53.23061595778876],
            [26.886888979381183, 53.23489106926286],
            [26.88403207536811, 53.23728494491735],
            [26.880032411007164, 53.240020638884005],
            [26.876604127269218, 53.24241422821251],
            [26.87546136512492, 53.24583340855759],
            [26.878603959449777, 53.248226672792214],
            [26.88346069474511, 53.24925231625713],
            [26.887174669692797, 53.25044886922581],
            [26.893459856545746, 53.25318372232039],
            [26.894316927480133, 53.25711476658881],
            [26.893459856545746, 53.2759104197022],
            [26.895459688726135, 53.284451167653],
            [26.89745952180482, 53.290087126181845],
            [26.89745952180482, 53.29503932405123],
            [26.89660244997208, 53.30477128237101],
            [26.899173663673764, 53.31023386590033],
            [26.900316424919765, 53.313988986835966],
            [26.89688814118182, 53.31740244601332],
            [26.893113172254516, 53.31909371810082],
            [26.891174334053744, 53.31996236178884],
            [26.88231793349911, 53.32183953537606],
            [26.873175842632918, 53.32218083079306],
            [26.866890655780196, 53.320644979919905],
            [26.861462538963337, 53.31876775324912],
            [26.85460597058932, 53.31757311180627],
            [26.84203559598535, 53.316890444539354],
            [26.834893337299718, 53.316890444539354],
            [26.82375141425308, 53.31927973220223],
            [26.82003744020375, 53.32218083079306],
            [26.81860898864619, 53.32491109586255],
            [26.817751917711746, 53.32900616645418],
            [26.815466394321504, 53.33361265099268],
            [26.8126094912065, 53.335830410325855],
            [26.807467065599553, 53.33702454066571],
            [26.799467735979533, 53.337365714622024],
            [26.797182213487588, 53.33668336398006],
            [26.795468071618586, 53.33395385224185],
            [26.7957537619302, 53.32985925657664],
            [26.795182380408903, 53.32576426840728],
            [26.790325645113512, 53.32286341343843],
            [26.78175493487032, 53.32081563274676],
            [26.775469748017372, 53.31945039102493],
            [26.766041966839964, 53.31808510509069],
            [26.75718556628533, 53.319109073233676],
            [26.749471926976526, 53.322522123480496],
            [26.741472597356506, 53.324228545972915],
            [26.732330506490484, 53.32644679373067],
            [26.719474441574903, 53.32832368207352],
            [26.711189421643326, 53.326788052298014],
            [26.708618208839766, 53.32474045941376],
            [26.702047330777077, 53.32149823722938],
            [26.6980476664163, 53.32047432641082],
            [26.69147678835367, 53.320986284891035],
            [26.684905911189333, 53.32269276880078],
            [26.675478130011754, 53.32269276880078],
            [26.670621393817896, 53.322522123480496],
            [26.660907922328875, 53.32115693635291],
            [26.652622902397297, 53.3220101834259],
            [26.65005168959391, 53.326276163423415],
            [26.65662256765654, 53.329347404550276],
            [26.661193612640318, 53.33173599533501],
            [26.661479302951875, 53.33463624655229],
            [26.655194116098983, 53.33873038369114],
            [26.650337379905295, 53.34043615795059],
            [26.64376650274096, 53.34060673162378],
            [26.636624244055326, 53.34009500855706],
            [26.624339559762745, 53.343165254850305],
            [26.618911442946114, 53.34333581760711],
            [26.610912113326094, 53.34128901949424],
            [26.606341068342147, 53.338559802512634],
            [26.6000558805909, 53.335659817547935],
            [26.590628099413266, 53.334465648998105],
            [26.582628770691542, 53.33412445184291],
            [26.576343582940297, 53.33463624655229],
            [26.56691580176272, 53.33770688638538],
            [26.564630279270716, 53.34060673162378],
            [26.5594878527657, 53.3443591803574],
            [26.552059903768452, 53.34538251801007],
            [26.54406057504673, 53.34538251801007],
            [26.537775387295483, 53.34265356248591],
            [26.531490199544237, 53.340947876923735],
            [26.52234810957657, 53.34009500855706],
            [26.512634638087548, 53.34009500855706],
            [26.498921501339055, 53.34197129644832],
            [26.491779243551775, 53.3443591803574],
            [26.48749388798109, 53.347770210351314],
            [26.4849226751777, 53.35527351630196],
            [26.490922171719035, 53.36004765991163],
            [26.496921669158667, 53.36294598639091],
            [26.503581825387528, 53.36474668503422],
            [26.509831301512918, 53.36634487473515],
            [26.51250964829552, 53.370073751077996],
            [26.517419951029524, 53.37540015156878],
            [26.51666381255677, 53.38126383213262],
            [26.498740597700532, 53.38185777261822],
            [26.47358621922882, 53.38352485758628],
            [26.459611564022623, 53.38352485758628],
            [26.437252116591992, 53.37935702240884],
            [26.410700272599513, 53.377689773764075],
            [26.392533220831524, 53.369352552978],
            [26.375763634584246, 53.362681601474776],
            [26.36867795172617, 53.36115925609488],
          ],
        ],
      },
      properties: {
        shapeName: "Nyasvizh",
        shapeISO: "",
        shapeID: "67162791B10653728732828",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
